module.exports = __webpack_public_path__ + "static/Outfit-SemiBold-86a20ec925c014f6e10d3e504e1d96fe.woff2";